import React from "react";
import { icons } from "../../assets/icons";
import ObserverEmitter, { EVENTS } from "../../emitter/Observer";
import { audiosAssets } from "../../assets/audio";
// import { useLocation } from "react-router-dom";


export const ButtonHome = () => {
	// const location = useLocation()
	const goHome = () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.navigationHomePause)
		// const path_parts = location.pathname.split("/")
		// const home_part = "/" + path_parts[1]
		window.location.href = "/home1";
	};
	return (
		<div className="fixed z-40 top-5 right-5">
			<div onClick={goHome} className="w-12 h-12 p-3 rounded-full bg-[#00000074] cursor-pointer">
				<img className="h-full w-full object-contain" src={icons.home} alt="play" />
			</div>
		</div>
	);
};
